import * as React from 'react';
import { useState, useEffect } from 'react';
import { IFaceplate } from 'components/FaceplateManager';

function SingleWindowTab(props: IFaceplate) {
    const { OnCollapse, Height, Width, indexFaceplate } = props;
    const toggleCollapse = () => {
        if (OnCollapse) {
            OnCollapse(props.indexFaceplate, Height, Width);
        }
    };

    let tabToRender;

    switch (props.size.toUpperCase()) {
        case 'SPECIALWIN':
            tabToRender = <></>;
            break;
        default:
            tabToRender = (
                <div>
                    <div
                        key={props.id}
                        id={props.id.toString()}
                        className={`tab ${props.collapse === true ? 'active' : ''}`}
                        title={props.title != '' ? props.title : props.indexFaceplate}
                        onClick={toggleCollapse}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="svg_content"
                            x="700"
                            y="510.25"
                            viewBox={`0 0 100 15`}
                            transform="matrix(1,0,0,1,0,0)"
                            preserveAspectRatio="none"
                            style={{
                                cursor: 'default',
                                height: '25px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                            <g transform="matrix(1,0,0,1,0,0)" id="left">
                                <g className="rect-group">
                                    <rect
                                        transform="matrix(1,0,0,1,0,5)"
                                        id="rect1"
                                        className="rect"
                                        width="100px"
                                        height="10"
                                    />
                                    <rect
                                        transform="matrix(1,0,0,1,0,0)"
                                        id="rect2"
                                        className="rect"
                                        width="100px"
                                        height="10"
                                        rx="6"
                                        ry="6"
                                    />
                                </g>
                            </g>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" id="svg_text" preserveAspectRatio="none">
                            <linearGradient id="circleGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style={{ stopColor: '#eaf4dd' }} />
                                <stop offset="100%" style={{ stopColor: '#cae385' }} />
                            </linearGradient>
                            <circle cx="16" cy="13" r="7" fill="url(#circleGradient)" stroke="#28488a" />
                            <text x="30" y="18" fill="black">
                                {props.title != '' ? props.title : props.indexFaceplate}
                            </text>
                        </svg>
                    </div>
                </div>
            );
    }

    return <React.Fragment>{tabToRender}</React.Fragment>;
}

export default SingleWindowTab;
